import { useRef, useCallback, useState } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import { Header } from './Header';
import { LinkedNotesTable } from './LinkedNotesTable';
import { ContactNote } from './types/ContactNote.type';
import { ContactNoteWrapperWC } from '@juliusbaer-gcrm/pcc-contact-note-components';
import { ZfTextButton } from '@zafire/react';

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error instanceof Error ? error.message : String(error)}</pre>
      <ZfTextButton onClick={resetErrorBoundary}>Try again</ZfTextButton>
    </div>
  );
}

export default function App() {
  const [linkedNotes, setLinkedNotes] = useState<ContactNote[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  const [brUId, setBrUId] = useState('b1111c61-1e4c-4d45-aaf1-41e331d42c11');
  const [partnerUId, setPartnerUId] = useState('');

  const handleAction = useCallback((action: { type: string; payload: any }) => {
    if (action.type === 'NOTES_LINKED') {
      setLinkedNotes(action.payload);
    }
    if (action.type === 'NOTE_UNLINKED') {
      setLinkedNotes((prevNotes: ContactNote[]) =>
        prevNotes.filter((note: ContactNote) => note.id !== action.payload.id),
      );
    }
  }, []);

  const linkedNoteUIDs = linkedNotes.map((note) => note.uid).filter(Boolean) as string[];

  return (
    <>
      <div style={{ margin: '32px', display: 'flex', gap: '16px', alignItems: 'center', marginBottom: '100px' }}>
        <div>
          <label htmlFor="brUId" style={{ display: 'block', marginBottom: '4px' }}>
            brUId
          </label>
          <input id="brUId" type="text" value={brUId} onChange={(e) => setBrUId(e.target.value)} />
        </div>
        <div>
          <label htmlFor="partnerUId" style={{ display: 'block', marginBottom: '4px' }}>
            partnerUId
          </label>
          <input id="partnerUId" type="text" value={partnerUId} onChange={(e) => setPartnerUId(e.target.value)} />
        </div>
      </div>
      <section ref={containerRef} style={{ margin: '32px' }}>
        <Header />
        <br />
        {linkedNotes.length > 0 && (
          <LinkedNotesTable
            notes={linkedNotes}
            onUnlink={(note) => handleAction({ type: 'NOTE_UNLINKED', payload: note })}
          />
        )}
        <br />
        <br />
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <ContactNoteWrapperWC
            env="DEV"
            version="0.0.1"
            linkedNoteUIDs={linkedNoteUIDs}
            allowUnlink={true}
            partnerUId={partnerUId || ''}
            brUId={brUId || ''}
            size="medium"
            callbackFunc={handleAction}
          />
        </ErrorBoundary>
      </section>
    </>
  );
}
